import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';

interface CountResponse { count: number }

export interface ChartData {
  label: string;
  value: number;
}

export interface DashboardStats {
  ongoingProjectsCount: number;
  ongoingFatsCount: number;
  compliantFatsCount: number;
  nonCompliantFatsCount: number;
  subcontractorsCount: number;
  projectsTrend: ChartData[];
  fatsTrend: ChartData[];
}

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private readonly baseUrl = `${environment.apiUrl}/projects/stats`;

  constructor(private http: HttpClient) { }

  getOngoingProjectsCount(scope: 'global' | 'me' = 'global'): Observable<number> {
    return this.http.get<CountResponse>(`${this.baseUrl}/ongoing-count`, { params: { scope } }).pipe(map(r => r.count));
  }

  getFatEnCoursCount(scope: 'global' | 'me' = 'global'): Observable<number> {
    return this.http.get<CountResponse>(`${this.baseUrl}/fat-encours-count`, { params: { scope } }).pipe(map(r => r.count));
  }

  getDashboardStats(startDate: string, endDate: string, scope: 'global' | 'me' = 'global'): Observable<any> {
    const apiUrl = `${environment.apiUrl}/dashboard/stats`;
    return this.http.get<any>(apiUrl, {
      params: { startDate, endDate, scope }
    });
  }
}
